'use strict';

/**
 * @class
 * Example use:
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  window.addEventListener('resize', resizeDebouncer.run, false);
 *  
 * Or, if using JQuery (but you can also 
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  $(window).bind('resize', resizeDebouncer.run);
 * 
 * Or, all on one line:
 *  $(window).bind('resize', (new Debouncer(callbackFn)).run);
 */
function Debouncer(callback) {
	var self = this;
	
	this._callback = callback;
	this._requestAnimationFrame = null;
	
	/**
	 * This will run the callback provided during construction of a Debouncer.
	 * Any passed arguments to run(...) will be passed to the callback.
	 * Calls are debounced using requsetAnimationFrame.
	 * @public
	 */
	this.run = function() {
		_run(self, this, arguments);
	}
}

/**
 * @private
 */
function _run(debouncer, thisArg, args) {
	debouncer.cancel();
	debouncer._requestAnimationFrame = requestAnimationFrame(function() {
		debouncer._callback.apply(thisArg, args);
	});
}

/**
 * Run the callback method immediately without debouncing.
 * Any active debouncing is canceled first.
 * @public
 */
Debouncer.prototype.runNow = function() {
	this.cancel();
	this._callback.apply(this, arguments);
}
/**
 * Cancel a call to 'run'.
 * @public
 */
Debouncer.prototype.cancel = function() {
	cancelAnimationFrame(this._requestAnimationFrame);
}

module.exports = Debouncer;
